export default {
  goodsStatusEnum: {
    '-1': 'Aguardando pagamento',
    0: 'Aguardando compra',
    1: 'Aguardando confirmação',
    2: 'Aguardando pagamento adicional',
    3: 'Produto devolvido',
    4: 'Produto trocado',
    5: 'Enviado',
    6: 'Enviado separadamente',
    7: 'Processamento adiado',
    8: 'Recebido',
    9: 'Chegou',
    10: 'Armazenado',
    11: 'Pedido cancelado',
    12: 'Produto destruído',
    13: 'Pedido vencido',
    14: 'Confirmação de informações',
    15: 'Confirmação de compra',
    16: 'Aguardando devolução',
    17: 'Aguardando troca',
    18: 'Devolução em processamento',
    19: 'Troca em processamento',
    20: 'Devolução concluída',
    21: 'Troca concluída',
    22: 'Pedido feito',
    23: 'Em processamento',
    24: 'Pedido cancelado',
    25: 'Pedido anormal',
    26: 'Devolução aguardando reembolso',
    27: 'Troca aguardando envio do vendedor',
    28: 'Saindo do armazém',
    29: 'Empacotamento de saída concluído',
    30: 'Enviado para o exterior',
    31: 'Produto recebido',
    32: 'Pedido recusado',
    33: 'Revisão de controle de risco',
    34: 'Reembolso concluído',
    35: 'Lista congelada',
    36: 'Pagamento adicional agendado',
    37: 'Aguardando saída do armazém',
    38: 'Reembolso em processamento',
    39: 'Produto recusado',
    40: 'Recusa concluída',
    41: 'Anormal não armazenado',
    42: 'Anormal já armazenado',
    43: 'Devolução cancelada',
    44: 'Troca cancelada',
    45: 'Recebido aguardando processamento',
    46: 'Aguardando compra',
    47: 'Panamá aguardando pagamento',
    48: 'Pagamento concluído',
    49: 'Produto abandonado',
    50: 'Forçar conclusão',
    51: 'Devolução aguardando consentimento do vendedor',
    52: 'Troca aguardando consentimento do vendedor',
    53: 'Pacote devolvido cancelado',
    54: '1688 aguardando geração',
    55: '1688 aguardando pagamento',
    58: 'Produto em transferência',
    61: `Aguardando compra`,
    62: `Aguardando compra`,
  },
  appendStatusEnum: {
    0: 'Aguardando processamento',
    1: 'Em processamento',
    2: 'Cancelado',
    3: 'Concluído',
    4: 'Pedido cancelado',
  },
  inviteStatusEnum: {
    0: 'Não ativado',
    1: 'Ativado',
  },
}
